module.exports = __webpack_public_path__ + "img/boxed_meals_3.93a122dc.jpg";